import React from 'react';
import { motion } from 'framer-motion';

const TestimonialSection = () => {
  const testimonials = [
    {
      message: "Before AWA AI, customers missed messages daily... now everything reply aaguthu auto!",
      author: "Ramesh, Chennai Retailer",
      type: "sent"
    },
    {
      message: "Leads vanthu follow-up panna mudiyala... ippo system la 24x7 nurture aaguthu!",
      author: "Kavitha, Coach Coimbatore", 
      type: "received"
    },
    {
      message: "Manual work nala staff tired aaguthu... ippo AI handle pannuthu, naanga only closing panrom.",
      author: "Murugan, Madurai Manufacturer",
      type: "sent"
    }
  ];

  return (
    <section className="py-12 sm:py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-6">
            💬 Hear From Happy Business Owners
          </h2>
        </motion.div>

        <div className="space-y-6 sm:space-y-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: testimonial.type === 'sent' ? 50 : -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              className={`flex ${testimonial.type === 'sent' ? 'justify-end' : 'justify-start'}`}
            >
              <div className={`max-w-xs sm:max-w-md lg:max-w-lg p-4 sm:p-6 rounded-2xl shadow-lg ${
                testimonial.type === 'sent' 
                  ? 'bg-green-500 text-white rounded-br-none' 
                  : 'bg-white text-gray-800 rounded-bl-none'
              }`}>
                <p className="text-base sm:text-lg mb-3 leading-relaxed">
                  "{testimonial.message}"
                </p>
                <p className={`text-sm font-semibold ${
                  testimonial.type === 'sent' ? 'text-green-100' : 'text-gray-600'
                }`}>
                  – {testimonial.author}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;